<div class="row font-13">
    <div class="col-5 text-center">
        2020 © <b>PCS Management Consultancy Pvt. Ltd.</b> - All rights reserved.
    </div>
    <div class="col-7" style="color: red;">
        <marquee>
            <h5>For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241
            </h5>
        </marquee>
    </div>
</div>